export default "__VITE_ASSET__5WYWgawd__"